import { useMemo } from 'react';
import { useFetchAffectedItems } from '@retail/calculus/data-access';
import { AssortmentPricesComparison } from '@retail/my-assortment/types';
import { useUserBrands } from '@retail/app/stores/selected-context';
import { brandLogo } from '@retail/utils';

interface Props {
  assortmentId: number;
  supplierNumber: number;
  conditionIds: number[];
}

export const useAffectedItems = ({ assortmentId, supplierNumber, conditionIds }: Props) => {
  const { selectedBrand } = useUserBrands();

  const { data: affectedItemsDto = [], isLoading } = useFetchAffectedItems({
    assortmentId,
    conditionIds,
    supplierNumber,
    suspense: false,
  });

  const affectedItems = useMemo(
    () =>
      affectedItemsDto.map((item) =>
        AssortmentPricesComparison.fromDTO(item, {
          name: selectedBrand.name,
          id: selectedBrand.brandId,
          imgUrl: brandLogo(selectedBrand.brandId).logo,
        })
      ),
    [affectedItemsDto, selectedBrand.brandId, selectedBrand.name]
  );

  return {
    items: affectedItems,
    totalItems: affectedItems.length,
    isLoading,
  };
};
